import { Box, Flex } from '@chakra-ui/react';

import { BulkActionBarProps } from './BulkActionBar.types';

function BulkActionBar({ onDeselectAll, selectedCount, cta, ...props }: BulkActionBarProps) {
  return (
    <Flex
      flex="1"
      direction="row"
      justify="space-between"
      align="center"
      w="full"
      p="6px 10px"
      borderRadius="10px"
      bg="brand.mutedPurple"
      color="brand.white"
      {...props}
    >
      <Flex direction="row" align="center" gap="20px">
        <Box
          p="10px 15px"
          bg="brand.darkGray"
          borderRadius="5px"
          color="brand.white"
          minW="28px"
          textAlign="center"
          sx={{ fontVariantNumeric: 'tabular-nums' }}
        >
          {selectedCount}
        </Box>
        <Box>selected</Box>
        <Box
          borderBottom="1px"
          borderColor="brand.white"
          role="button"
          onClick={onDeselectAll}
          _hover={{ borderColor: 'brand.purple', color: 'brand.purple' }}
          cursor="pointer"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              onDeselectAll();
            }
          }}
        >
          Deselect all
        </Box>
      </Flex>

      {cta}
    </Flex>
  );
}

export default BulkActionBar;
